/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssessmentsFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    id?: boolean;
    title?: boolean;
    description?: boolean;
    instructions?: boolean;
    assessmentType?: boolean;
    status?: boolean;
    startDate?: boolean;
    endDate?: boolean;
    hideParticipantIdentity?: boolean;
    allowMultipleResponses?: boolean;
    showResultsToParticipants?: boolean;
    requireLogin?: boolean;
    maxResponses?: boolean;
    useCompanyParticipants?: boolean;
    companyId?: boolean;
}

